import platformMiddleware from '/app/middleware/platform.global';
import updateMiddleware from '/app/middleware/update.global';
import inpersonateMiddleware from '/app/middleware/inpersonate.global';
import { createRouter, createWebHistory } from 'vue-router';
import options from './options';
import { config } from '/app/config';
import { isIgnoredAppUpdatePath } from '/app/utils/app-update';
import { canRecoveryReload } from '/app/utils/navigation';

const router = createRouter({
    ...options,
    history: createWebHistory(config.app.basePath),
});

router.beforeEach(platformMiddleware)
router.beforeEach(inpersonateMiddleware)
router.beforeEach(updateMiddleware)

// Recover from stale async chunks after a deployment: when Vue Router fails to
// resolve a lazy-loaded component, reload to pick up the newly deployed assets.
router.onError((error, to) => {
    const message = error?.message || '';
    const isStaleChunk = /Couldn't resolve component|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message);
    if (isStaleChunk && to?.fullPath && !isIgnoredAppUpdatePath(to.path) && canRecoveryReload()) {
        window.location.assign(to.fullPath);
    }
});

export default router;
